import { useContext } from 'react'
import { TimelineContext } from '../context/timelineContextCore'
import { AuthContext } from '../context/authContextCore'

export interface AccessRestrictionState {
  restricted: boolean
  uid: string
}

export const useAccessRestriction = (): AccessRestrictionState => {
  const timelineContext = useContext(TimelineContext)
  const authContext = useContext(AuthContext)
  const restricted = Boolean(timelineContext?.isAccessRestricted)
  const uid = authContext?.user?.uid ?? authContext?.currentUser?.uid ?? ''
  return { restricted, uid }
}
